import React from "react";

type Props = {
  // The value the game uses now (modified while an event modifier runs).
  value: React.ReactNode;
  // The value without the modifier; nothing extra is shown when it is missing or equal.
  original?: React.ReactNode;
  // Colours the value as a buff or a nerf; worked out from the two values when both are numbers.
  direction?: "up" | "down";
  className?: string;
};

const asNumber = (value: React.ReactNode) => {
  if (typeof value === "number") return value;
  if (typeof value !== "string" || value.trim() === "") return NaN;
  return Number(value.replace(/,/g, ""));
};

// A modified stat: the original small with a diagonal strike, then the modified value.
// Never used for Range, which modifiers do not change.
const ModifiedStat = ({ value, original, direction, className }: Props) => {
  const now = asNumber(value);
  const before = asNumber(original);
  if (
    original === undefined ||
    original === null ||
    original === "" ||
    String(original) === String(value) ||
    (!Number.isNaN(now) && now === before)
  )
    return <>{value}</>;

  const resolved =
    direction ??
    (Number.isNaN(now) || Number.isNaN(before)
      ? undefined
      : now > before
      ? "up"
      : "down");

  return (
    <span
      className={
        "modified-stat" +
        (resolved ? " modified-stat--" + resolved : "") +
        (className ? " " + className : "")
      }
    >
      <span className="modified-stat__original">{original}</span>
      <span className="modified-stat__value">{value}</span>
    </span>
  );
};

export default ModifiedStat;
